module.exports = "/src/views/player/help/images/inkas2.jpg";